// Client-side navigation (B-004).
//
// The app routes by branching on `window.location.pathname` in App.tsx rather than
// with a router library. TanStack Router is a dependency and the original plan was to
// adopt it in Phase 1, but that never happened — so navigation is still
// pushState + a synthetic popstate to make App re-render.
//
// That two-line incantation was copy-pasted into five places (App, Gateway,
// CommandPalette, VoucherTypeSwitcher, MoneyVoucherEntry). Every copy is a chance to
// forget the dispatch, which produces the worst kind of bug: the URL changes, the page
// does not, and nothing errors. This module is the single definition.
//
// When the router migration does happen, it happens HERE — every caller already goes
// through this function, so the swap is one file rather than a hunt.

/** Navigate to an in-app path and make the path-based router re-render. */
export function navigateTo(path: string) {
  window.history.pushState({}, '', path);
  // App.tsx listens on popstate. pushState alone does NOT fire it — that is the
  // detail every hand-rolled copy of this risks omitting.
  window.dispatchEvent(new PopStateEvent('popstate'));
}

/** Replace the current entry instead of pushing — for redirects that shouldn't be "back"-able. */
export function replaceWith(path: string) {
  window.history.replaceState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}
